"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseException = exports.IdNotMatchException = void 0;
const tslib_1 = require("tslib");
const ErrorCode_1 = (0, tslib_1.__importDefault)(require("./ErrorCode"));
class IdNotMatchException extends Error {
    constructor(requestId, responseId) {
        super(`Expect json rpc id to be ${requestId}, but ${responseId} received`);
        this.code = ErrorCode_1.default.IdNotMatch;
    }
}
exports.IdNotMatchException = IdNotMatchException;
class ResponseException extends Error {
    constructor() {
        super(...arguments);
        this.code = ErrorCode_1.default.ResponseMessage;
    }
}
exports.ResponseException = ResponseException;
exports.default = {
    IdNotMatchException,
    ResponseException,
};
//# sourceMappingURL=rpc.js.map